import { defineStore } from 'pinia'
import axios from 'axios'
import { useUserStore } from './userStore'
import { useErrorStore } from './errorStore'


export const useBalanceStore = defineStore({
  id: 'balances',
  state: () => ({
    user_input_output_balance: null,
    totalItems: 0, // Общее количество элементов
    loading: false, // Состояние загрузки
    selectedCurrency: parseInt(localStorage.getItem('selectedCurrency')) || 1, // 1 - адена, 2 - эйнхасад
    currency_name: null,        // название 1-й валюты из БД (напр. "Адена")
    currency_name_second: null, // название 2-й валюты из БД (напр. "Эйнхасад")
    default_currency: false,    // дефолтная валюта: false = 1-я, true = 2-я
    manual_processing: false,   // ручная обработка: дарить коды нельзя, только написать в Telegram
    wallet: {
      gamesserver: null,
      nick: null,
      gamesserver_id: null,
      balance: 0,
      balance_second: 0,
      new_message: false
    }



  }),

  getters: {
    // Получение текущего баланса в зависимости от выбранной валюты
    getCurrentBalance: (state) => {
      return (currencyType = null) => {
        const currency = currencyType || state.selectedCurrency || 1
        return currency === 1 ? state.wallet.balance : state.wallet.balance_second
      }
    },

    // Получение названия текущей валюты
    getCurrentCurrencyName: (state) => {
      return (currencyType = null) => {
        const currency = currencyType || state.selectedCurrency || 1
        // Если в БД заданы названия валют — используем их, иначе fallback
        return currency === 1
          ? (state.currency_name || 'аден')
          : (state.currency_name_second || 'монет эйнхасад')
      }
    }
  },

  actions: {
    async get_balance(data) {
      if (data.wallet != null && typeof data.wallet === 'object') {
        Object.assign(this.wallet, data.wallet)
      } else {
        this.wallet.balance = 0
        this.wallet.balance_second = 0
      }
      this.wallet.gamesserver_id = data.id
      this.wallet.gamesserver = data.gamesserver
      this.wallet.nick = data.nick

      // Сохраняем названия валют и дефолтную валюту сервера
      this.currency_name = data.currency_name || null
      this.currency_name_second = data.currency_name_second || null
      // Number() защищает от строк "0"/"1", чтобы "0" не считался true
      this.default_currency = Number(data.default_currency) === 1
      this.manual_processing = Number(data.manual_processing) === 1

      // Если сервер настроен на показ 2-й валюты по умолчанию — переключаем сразу
      this.selectedCurrency = this.default_currency ? 2 : 1
      localStorage.setItem('selectedCurrency', this.selectedCurrency.toString())
      //console.log(this.wallet, data);

    },
    async minus_balance(summa) {

      this.wallet.balance = Number(this.wallet.balance) - Number(summa)
    },
    async plus_balance(summa) {

      this.wallet.balance = Number(this.wallet.balance) + Number(summa)
    },


    async get_user_input_output_balance(page = 1, perPage = 10) {
      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        this.loading = true;
        const response = await axios.get('/api/get_user_input_output_balance', {
          params: {
            page,
            per_page: perPage,
          },
        })
        this.user_input_output_balance = response.data.data
        this.totalItems = response.data.total
        return this.user_input_output_balance
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false;
      }
    },

    async up_balance_user(data) {

      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        data.currency_type = this.selectedCurrency
        let response
        if (this.selectedCurrency == 2) {
          response = await axios.post('/api/up_balance_user_second_currency/', data)
        } else {
          response = await axios.post('/api/up_balance_user/', data)
        }
        return response
      } catch (e) {
        return useErrorStore().data
      }
    },

    async delete_balance_user(id) {

      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        const response = await axios.get('/api/delete_balance_user/' + id)
        return response
      } catch (e) {
        return useErrorStore().data
      }
    },
    async down_balance_user(data) {

      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        data.currency_type = this.selectedCurrency
        let response
        if (this.selectedCurrency == 2) {
          response = await axios.post('/api/down_balance_user_second_currency/', data)
        } else {
          response = await axios.post('/api/down_balance_user/', data)
        }
        if (response.data.success) {
          if (this.selectedCurrency == 2) {
            this.wallet.balance_second = this.wallet.balance_second / 1 - response.data.success.enter_currency / 1
          } else {
            this.wallet.balance = this.wallet.balance / 1 - response.data.success.enter_currency / 1
          }
        }
        return response
      } catch (e) {
        return useErrorStore().create_errors(e)
      }
    },
    async delete_request(data) {

      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        const response = await axios.post('/api/delete_request/', data)
        if (response.data.success) {
          let i = this.user_input_output_balance.findIndex(a => a.id === response.data.success)
          this.user_input_output_balance.splice(i, 1)
        }
        return response
      } catch (e) {
        console.log(e)
      }

    },

    update_balance_user(data) {
      if (this.wallet.gamesserver_id == data.gamesserver_id) {
        Object.assign(this.wallet, data)



      }

    },


    // Переключение валюты с сохранением в localStorage
    switchCurrency(currencyType) {
      console.log('switchCurrency called with:', currencyType)
      this.selectedCurrency = currencyType
      localStorage.setItem('selectedCurrency', currencyType.toString())
      console.log('selectedCurrency is now:', this.selectedCurrency)
    },



  }
})
